import React from 'react';
import { ImportedController } from 'react-imported-component';
import { HelmetProvider } from 'react-helmet-async';
import { TrackableProvider } from '@finect/front-gtm';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from '../../ErrorBoundary';
export var ClientApp = function ClientApp(_ref) {
  var children = _ref.children;
  return React.createElement(ImportedController, null, React.createElement(HelmetProvider, null, React.createElement(BrowserRouter, null, React.createElement(TrackableProvider, null, React.createElement(ErrorBoundary, null, children)))));
};